var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSbp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 17,
    fill: "#F2F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9999 16.5751C18.9958 16.5751 20.6124 14.9585 20.6124 12.9626C20.6124 10.9667 18.9958 9.3501 16.9999 9.3501C15.004 9.3501 13.3874 10.9667 13.3874 12.9626C13.3874 14.9585 15.004 16.5751 16.9999 16.5751ZM16.9999 18.3813C14.5886 18.3813 9.7749 19.5915 9.7749 21.9938V23.8001H24.2249V21.9938C24.2249 19.5915 19.4112 18.3813 16.9999 18.3813Z",
    fill: "#141233"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 16.5,
    fill: "white",
    stroke: "#F2F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 10.8521L11.6604 15.6768V18.6198L9.00311 23.435L9 10.8521Z",
    fill: "#5B57A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2148 13.9208L21.7077 12.3706L26.8095 12.3657L19.2148 17.0863V13.9208Z",
    fill: "#D90751"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2008 10.8233L19.2149 17.2111L16.5483 15.5486V6L19.201 10.8233H19.2008Z",
    fill: "#FAB718"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8095 12.3657L21.7076 12.3705L19.2008 10.8233L16.5483 6L26.8094 12.3657H26.8095Z",
    fill: "#ED6F26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2149 23.4615V20.3623L16.5483 18.7314L16.5498 28.2896L19.2149 23.4615Z",
    fill: "#63B22F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7013 21.9257L11.6602 15.6768L9 10.8521L26.7985 21.9194L21.7011 21.9257H21.7013Z",
    fill: "#1487C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5498 28.2895L19.2146 23.4614L21.7012 21.9253L26.7984 21.9189L16.5498 28.2895Z",
    fill: "#017F36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00293 23.4342L16.5697 18.7311L14.0258 17.1475L11.6602 18.6189L9.00293 23.4342Z",
    fill: "#984995"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 17,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSbp);
export default __webpack_public_path__ + "static/media/sbp.3c0cac22.svg";
export { ForwardRef as ReactComponent };